// Yodlee FinApp Application Names
export const FASTLINK = 'FastLink';
export const FINANCIAL_WELLNESS = 'Financial Welness';
export const ADVICE_FASTLINK = 'Advice FastLink';
export const SETTINGS = 'Settings';

// Yodlee FinApp Application IDs
export const FASTLINK_APP_ID = 10003600;
export const FINANCIAL_WELLNESS_APP_ID = 10003700;
export const SETTINGS_APP_ID = 10003659;

// Yodlee Finapp Module IDs
export const LINK_ACCNT_ID = 10003591;
export const EDIT_ACCNT_ID = 10003596;

// Yodlee Finapp Message Constants
export const FINAPP_RESIZE_MESSAGE = 'FinAppResizeMessage';
export const FINAPP_MODULE_MESSAGE = 'FinAppModuleMessage';
export const FINAPP_STATUS_MESSAGE = 'FinAppStatusMessage';

// FinApp Standard Flow Launch From Edit Flow
export const STANDARD_FLOW = 'standard-flow';
export const FINAPP_EXIT = 'exit';

// FinApp Visited Cookie String
export const FINAPP_COOKIE_STRING = 'FINAPP=';

// FinApp Output Responses
export const SUCCESS = 'SUCCESS';
export const NO_MAPPING = 'NO_MAPPING';
export const REFRESH_ACCOUNT_ERROR = 'REFRESH_ERROR';
export const INSTANCE_ERROR = 'INSTANCE_ERROR';

// FinApp Consent
export const CONSENT_ACCEPTED = 'CONSENT_ACCEPTED';
